export const performance = {
  sections: [
    "Training & Enablement Review",
    "Mentorship Review",
    "Project Review",
    "General",
    "Training Requirements",
  ],
  sectionData: {
    "Training & Enablement Review": {
      description:
        "In this section, you will be evaluated on the training & development activities that you have participated in. *Please provide details for the past 12 months only",
      questions: [
        "1. Which certifications have you completed? *Multiselect",
        "2. Have you completed any certifications other than those listed above in past twelve months? If yes, please specify. *",
        "3. Select the exercises you have completed (You may choose multiple options): *",
        "4. How many Mock/Client Interviews have you given during the last 12 months? *",
        "5. If you have given the mock interviews or client interviews, write in detail about the interviews given. If No, write N.A. (Not Applicable) *",
        "6. How many Expert-Led sessions (Formerly known as Classroom sessions) have you presented during the last 12 months? *",
        "7. If you have presented on any topic in CoffeeNLearn session, mention the topics presented along with the dates on which the topic was presented and explain in detail. If No, write N.A. (Not Applicable) *",
        "8. Have you appeared as a speaker in any of the MuleSoft Meetups? *",
        "9. If you appeared as a speaker in any of the MuleSoft Meetups, write in detail about all the Meetups where you were a Speaker. Mention the Meetup locations, dates and topics on which you presented. Else, Write N.A. (Not Applicable) *",
        "10. Have you presented at any MuleSoft or Salesforce events other than Meetup as a speaker? If yes, please provide the event location, date, and topic. If not, write N.A. (Not Applicable) *",
        "11. Are you a MuleSoft Meetup Leader? *",
        "12. Are you a MuleSoft Mentor? *",
        "13. Are you a MuleSoft Ambassador? *",
        "14. How many Salesforce Sessions have you presented during the last 12 months? *",
        // "15. Have you completed the Caelius AI Enablement Program? *",
      ],
    },
    "Mentorship Review": {
      description:
        "How many employees have you mentored during the Review Period? *Please provide details for the past 12 months only.",
      questions: [
        "15. How many employees have you assisted during the Review Period as a Training Buddy? (Last 12 months) Kindly Specify. If not, write N.A. (Not Applicable) *",
        "16. How many employees have you assisted during the Review Period as a Mentor/Advisor/Lead? (Last 12 months) Kindly Specify. If not, write N.A. (Not Applicable) *",
        "17. How many reviews have you taken as a Reviewer? Kindly Specify. If not, write N.A. (Not Applicable) *",
      ],
    },
    "Project Review": {
      description:
        "In this section, you are required to mention in detail about all the projects you have worked on or are currently working on.",
      questions: [
        "18. No. of Projects undertaken. (last 12 months) *",
        '19. Project Details (Please mention "Name of the Project, Client, Description of the Project, Role, Technology, Duration, Responsibilities" in detail for every project) *',
        "20. How many code reviews have you taken in the past 12 months? Please provide the related code review sheet or PR link; if not applicable, write N.A. *",
        // "22. How many code reviews have you taken in the past 12 months? Please attach the code review sheet/PR Link. If not, write N.A. (Not Applicable)",
        "21. How many architectural solutions have you designed for use cases in the past 12 months? Please specify the use cases along with the associated project names. If not, write N.A. (Not Applicable)",
        "22. Achievements/Appreciations (if any)",
        "23. Did you receive a CSAT score of 5/5 on any projects during the period between January and March 31, 2026? If yes, mention the project name(s).*",
      ],
    },
    General: {
      description:
        "In this section, you are required to rate yourself in your own abilities and proficiency in the below mentioned areas. On a scale of 1 to 10, with 1 being the lowest, please rate yourself. The purpose is to gather your self-assessment and insights into your strengths, weaknesses and overall performance.",
      questions: [
        "24. Knowledge of Job Skills (ability to learn and apply new skills, displaying understanding of roles & responsibilities, requiring minimal supervision) *",
        "25. Technical Skills (proficiency and expertise in technical skills needed for the job) *",
        "26. Responsiveness (ability to provide solutions and respond quickly and proactively to clients, to any challenges faced or to any given situation) *",
        "27. Communication & Listening Skills (listen effectively and demonstrate the ability to express orally and in writing as required) *",
        "28. Ability to Work Across Different Teams (work cooperatively with others and offer assistance and support when needed) *",
        "29. Flexibility to Work in Different Time Zones (willingness to accommodate to the needs and demands of clients, teams, or projects that operate in different time zones) *",
        "30. Inclusiveness (include others in team projects, treat others with respect and show empathy for others) *",
        "31. Initiative and Creativity (self-starter; ability to work and proceed with a task without being told to and come up with new ideas) *",
        "32. Write about the initiatives taken by you (if any) *",
      ],
    },
    "Training Requirements": {
      description: "",
      questions: [
        "33. Are there any specific areas of training or development where you want to improve and would want us to help you or invest in you? *",
        "34. Anything else that you want to share with us? *",
      ],
    },
  },
  marks: {
    certifications: {
      associate: 100,
      administrator: 100,
      architect: 400,
      consultant: 200,
      developer: 200,
    },
    otherCertifications: 1000,
    exercisesCompleted: 20,
    mockInterviewsGiven: 60,
    mockInterviewDetails: 10,
    expertLedSessionsPresented: 100,
    coffeeNLearnSessions: 100,
    isMuleSoftMeetupSpeaker: 500,
    meetupDetails: 500,
    eventDetails: 500,
    isMuleSoftMeetupLeader: 200,
    isMuleSoftMentor: 200,
    isMuleSoftAmbassador: 300,
    salesforceSessionsPresented: 500,
    completedCaeliusAIEnablementProgram: 500,
    trainingBuddyAssisted: 1000,
    mentorLeadAssisted: 1000,
    reviewsTaken: 500,
    projectsUndertaken: 500,
    projects: 1500,
    codeReviewsTaken: 1000,
    codeReviewsTakenArchitect: 500,
    architecturalSolutionsDesigned: 500,
    achievements: 1000,
    csatScore5Projects: 2000,
    selfAssessment: 10,
    initiativeDetails: 10,
    trainingDevelopmentNeeds: 10,
    additionalInfo: 10,
  },
};
